"use client";

import { memo } from "react";

const TABS = [
  { id: "live", label: "Trực tiếp" },
  { id: "h2h", label: "Lịch sử đối đầu" },
  { id: "form", label: "Thành tích gần đây" },
  { id: "odds", label: "So sánh kèo" },
];

function TabNavigation({ activeTab, onTabChange }) {
  return (
    <div className="flex justify-center overflow-x-auto rounded-lg border-none [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`shrink-0 px-4 py-2 text-sm font-medium transition-colors relative whitespace-nowrap border-0 rounded-md ${
            activeTab === tab.id
              ? "text-[var(--theme-primary)] bg-[var(--theme-foreground)] shadow-sm"
              : "text-[var(--theme-text-muted)] hover:text-[var(--theme-text)] hover:bg-[var(--theme-foreground)]/50"
          }`}
        >
          {tab.label}
          {activeTab === tab.id && (
            <span className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full bg-[var(--theme-primary)]" />
          )}
        </button>
      ))}
    </div>
  );
}

export default memo(TabNavigation);
